module.exports = __webpack_public_path__ + "img/svg/logo.41abdcac003d9fb972c018f5d0cec2b3.svg";